module.exports = __webpack_public_path__ + "images/saaremaa/apple-icon-60x60.png";